<template>
  <SoAdminPage title="Complaints">
    <OpsComplaintTable />
  </SoAdminPage>
</template>

<script lang="ts">
  import SoAdminPage from "@/components/templates/SoAdminPage.vue"
  import { defineComponent } from "vue"
  import OpsComplaintTable from "@/views/operations/complaints/components/OpsComplaintTable.vue"

  export default defineComponent({
    components: {
      SoAdminPage,
      OpsComplaintTable,
    },
  })
</script>
